import { useEffect, useState } from 'react';
import { shouldCheckForNotifications, setHasNotificationInStorage, setLastCheckedInStorage } from './utils';
import Raven from 'raven-js';
import { getBannerNotifications } from '../../api/persistentApi';
import isNotificationsDisable from '../../utils/isNotificationsDisable';
import { debug } from '../../utils/DebugUtil';
export const useGetBannerNotifications = () => {
  const [bannerNotifications, setBannerNotifications] = useState([]);
  useEffect(() => {
    const checkAndFetchNotifications = async () => {
      if (isNotificationsDisable()) {
        return;
      }
      try {
        const shouldCheck = await shouldCheckForNotifications();
        if (!shouldCheck) {
          debug('Persistent notifications status cached - not checking for new notifications');
          return;
        }
        debug('Checking for persistent notifications');
        const bannerRes = await getBannerNotifications();
        if (bannerRes && bannerRes.banner && bannerRes.banner.notifications) {
          const notifications = bannerRes.banner.notifications;
          await setHasNotificationInStorage(notifications);
          setBannerNotifications(notifications);
        } else {
          if (bannerRes === null) {
            return;
          }
          throw new Error('Unexpected structure from persistentNotifications response', {
            cause: bannerRes
          });
        }
        await setLastCheckedInStorage();
      } catch (err) {
        if (err instanceof Error) {
          throw err;
        }
      }
    };
    checkAndFetchNotifications().catch(err => {
      Raven.captureException(err);
    });
  }, []);
  return bannerNotifications;
};